var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .icon-line--style {\n        fill: none;\n        stroke: #000;\n        stroke-width: 4px;\n        stroke-linejoin: round;\n      }\n\n      .icon-line--miter-limit {\n        stroke-miterlimit: 10;\n      }\n\n      .icon-line--linecap {\n        stroke-linecap: round;\n      }\n    ")),React.createElement("circle",{"className":"icon-line--style icon-line--miter-limit icon-line--linecap","cx":"63.83","cy":"64.06","r":"56","key":1}),React.createElement("polyline",{"className":"icon-line--style icon-line--miter-limit icon-line--linecap","points":"32.02 65.54 49.37 87.66 93.62 42.69","key":2})]);
}

Tick.defaultProps = {"height":"44","id":"icon-tick","viewBox":"0 0 128 128"};

module.exports = Tick;

Tick.default = Tick;
